module.exports = __webpack_public_path__ + "img/hiking.6ddf5643.svg";